import React from 'react'
import * as ReactDOM from 'react-dom/client'
import Router from './routes'

import './index.css'
import 'react-toastify/dist/ReactToastify.css'

ReactDOM.createRoot(document.getElementById('root'))
  .render(<Router/>)
